<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <div class="topLeft">
        <h3>推广渠道报表 (公益课)<span class="time" v-if="updateTime">数据更新时间：{{timestampToDate(updateTime)}}</span></h3>
        <div class="refresh">按照团队维度汇总的完整数据链路，按公益课学期的开始时间周期来统计</div>
      </div>
      <div class="topRight">
        <el-select v-model="listType" class="selectWidth" @change="toggleSearch">
          <el-option
            v-for="item in allTime"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
        <el-date-picker
          v-model="createTime"
          value-format="timestamp"
          type="daterange"
          :picker-options="pickerOptions"
          :clearable="false"
          @blur="enableChoose"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:235px"
          @change="changeDate"
          ></el-date-picker>
        <div>公益课的开课时间</div>
      </div>
      <el-form :inline="true" :model="listQuery" label-width="100px">
        <el-form-item label="公益课学期ID">
          <el-input
            type="number"
            onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
            v-model="listQuery.b2c_term_id"
            placeholder="输入公益课学期ID查询"
            class="orderStyle numrule"
          />
        </el-form-item>
        <el-form-item label="公益课学期">
          <el-select v-model="listQuery.b2c_term_name" filterable placeholder="请选择公益课学期">
            <el-option label="全部学期" :value="null" />
            <el-option
              v-for="item in termList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推广渠道">
          <el-select v-model="listQuery.promotion_channel_id" filterable placeholder="请选择推广渠道">
            <el-option label="全部推广渠道" :value="null" />
            <el-option
              v-for="item in channelList"
              :key="item.id"
              :label="item.name"
              :value="item.promotionChannelCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="支付金额">
          <el-input v-model="listQuery.pay_amount" type="number" placeholder="输入支付金额" class="orderStyle" />
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
      </el-form>
      <funcBlock tit="详细数据" :showBorder=false>
        <div slot="blockCon">
          <i slot="blockTit" class="blockTit">
            <i slot="blockTit" class="blockTit">
              <el-button :class="{'btnCreate': true, btn: true}" type="primary" icon="el-icon-download" @click="exportExcel">下载表格</el-button>
            </i>
          </i>
          <el-table
            v-loading="listLoading"
            :data="dataList"
            border
            fit
            highlight-current-row
            style="width: 100%"
            :header-cell-style="tableHeader"
            :row-class-name="tableColumn"
            @sort-change="changeTableSort"
            :default-sort = "{prop: 'b2c_term_start_time', order: 'descending'}"
          >
            <el-table-column v-if="listType === 'term'" label="公益课学期ID" prop="b2c_term_id" align="center" min-width="130" fixed sortable='custom'>
              <template slot-scope="{row}">
                <span v-if="!row.b2c_term_start_time && !row.b2c_term_name" class="special-weight">{{ `总计 ${total} 条记录` }}</span>
                <span v-else>{{ row.b2c_term_id ? row.b2c_term_id : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="listType === 'term'" label="公益课学期名称" align="center" width="180" fixed>
              <template slot-scope="{row}">
                <el-tooltip class="item" effect="dark" :content="(!row.b2c_term_name && !row.b2c_term_start_time) ? '--' : row.b2c_term_name" placement="top">
                  <span>{{ row.b2c_term_name && row.b2c_term_name.length > 10 ? `${row.b2c_term_name.slice(0, 10)}...` : row.b2c_term_name || '--' }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column v-if="listType === 'term'" label="公益课开课时间" prop="b2c_term_start_time" align="center" min-width="160" sortable='custom'>
              <template slot-scope="{row}">
                <span>{{ row.b2c_term_start_time ? timestampToDate(row.b2c_term_start_time) : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="推广渠道名称" prop="promotion_channel_name" align="center" width="180">
              <template slot-scope="{row}">
                <el-tooltip class="item" effect="dark" :content="(listType === 'acc' && !row.b2c_term_start_time && !row.promotion_channel_name) ? '--' : row.promotion_channel_name" placement="top">
                  <span v-if="listType === 'acc' && !row.b2c_term_start_time && !row.promotion_channel_name" class="special-weight">
                    {{ `总计 ${total} 条记录`}}
                  </span>
                  <span v-else-if="listType === 'acc' && row.promotion_channel_name && row.promotion_channel_name !== '-'">
                    {{ row.promotion_channel_name.length > 10 ? `${row.promotion_channel_name.slice(0, 10)}...` : row.promotion_channel_name }}
                  </span>
                  <span v-else-if="listQuery.payType !== 'acc' && row.promotion_channel_name && row.promotion_channel_name === '-'" class="special-weight">--</span>
                  <span v-else>{{ row.promotion_channel_name && row.promotion_channel_name !== '-' ? row.promotion_channel_name.length > 10
                    ? `${row.promotion_channel_name.slice(0, 10)}...` : row.promotion_channel_name : '--'}}
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="公益课账号领取人数" prop="sum_b2c_num" align="center" min-width="180" sortable='custom'>
              <template slot-scope="{row}">
                <span>{{ row.sum_b2c_num ? numberFormat(row.sum_b2c_num) : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="公益课首课完课人数" prop="b2c_sum_0fin_num" align="center" min-width="180" sortable='custom'>
              <template slot-scope="{row}">
                <span>{{ row.b2c_sum_0fin_num ? numberFormat(row.b2c_sum_0fin_num) : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="公益课全部课完课人数" prop="b2c_sum_finish_num" align="center" min-width="190" sortable='custom'>
              <template slot-scope="{row}">
                <span>{{ row.b2c_sum_finish_num ? numberFormat(row.b2c_sum_finish_num) : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sum_l1_num" align="center" min-width="190" sortable='custom'>
              <template slot="header">
                <el-tooltip effect="dark" placement="top" content="只含支付成功且未退费的用户数">
                  <span>体验课支付人数 <i class="el-icon-info"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{row}">
                <span>{{ row.sum_l1_num ? numberFormat(row.sum_l1_num) : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sum_l1_rate" align="center" min-width="190" sortable='custom'>
              <template slot="header">
                <el-tooltip effect="dark" placement="top" content="体验课支付人数/公益课账号领取数">
                  <span>体验课领取率 <i class="el-icon-info"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{row}">
                <span>{{ row.sum_l1_rate ? toPercentage(row.sum_l1_rate) : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="体验课首课完课人数" prop="l1_sum_0fin_num" align="center" min-width="190" sortable='custom'>
              <template slot-scope="{row}">
                <span>{{ row.l1_sum_0fin_num ? numberFormat(row.l1_sum_0fin_num) : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="体验课全部课完课人数" prop="l1_sum_finish_num" align="center" min-width="190" sortable='custom'>
              <template slot-scope="{row}">
                <span>{{ row.l1_sum_finish_num ? numberFormat(row.l1_sum_finish_num) : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sum_annual_renewal_num" align="center" min-width="190" sortable='custom'>
              <template slot="header">
                <el-tooltip effect="dark" placement="top" content="体验课续报结束30天内的续报年课人数，续报30天内退费不算">
                  <span>精品课（年课）人数 <i class="el-icon-info"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{row}">
                <span>{{ row.sum_annual_renewal_num ? numberFormat(row.sum_annual_renewal_num) : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sum_annual_renewal_rate" align="center" min-width="220" sortable='custom'>
              <template slot="header">
                <el-tooltip effect="dark" placement="top" content="精品课（年课）人数/公益课账号领取人数">
                  <span>精品课（年课）续报率 <i class="el-icon-info"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{row}">
                <span>{{ row.sum_annual_renewal_rate ? toPercentage(row.sum_annual_renewal_rate) : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sum_quarter_renewal_num" align="center" min-width="190" sortable='custom'>
              <template slot="header">
                <el-tooltip effect="dark" placement="top" content="体验课续报结束30天内的续报季课人数，续报30天内退费不算">
                  <span>精品课（季课）人数 <i class="el-icon-info"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{row}">
                <span>{{ row.sum_quarter_renewal_num ? numberFormat(row.sum_quarter_renewal_num) : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sum_quarter_renewal_rate" align="center" min-width="220" sortable='custom'>
              <template slot="header">
                <el-tooltip effect="dark" placement="top" content="精品课（季课）人数/公益课账号领取人数">
                  <span>精品课（季课）续报率 <i class="el-icon-info"></i></span>
                </el-tooltip>
              </template>
              <template slot-scope="{row}">
                <span>{{ row.sum_quarter_renewal_rate ? toPercentage(row.sum_quarter_renewal_rate) : '--' }}</span>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total>=1"
            :total="total"
            :page.sync="listQuery.index"
            :limit.sync="listQuery.pageSize"
            @pagination="getList"
          />
        </div>
      </funcBlock>
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from 'js-cookie';
import Pagination from "@/components/Pagination/index";
import {
  getChannelList,
  getTermList,

  getChannelLists,
  getChannelSum,
  getChannelDownload,
  getChannelAccLists,
  getChannelAccSum,
  getChannelAccDownload,
} from "@/services/term";
import PowerWrapper from "@/components/PowerWrapper";
import funcBlock from '@/components/common/funcBlock'
import { timestampToDate, delUndefined, numFormat, timestampToDateTotal, deteleObject, toPercentage } from "@/utils/utils";
import { getTeamCode } from '@/utils/auth'

export default {
  name: "channel",
  components: {
    Pagination,
    PowerWrapper,
    funcBlock
  },
  data() {
    return {
      CurrRole: "channel",
      dataList: [],
      listQuery: {
        index: 1,
        pageSize: 10,
        b2c_term_id: null,
        b2c_term_name: null,
        promotion_channel_id: null,
        orderColumn: 'b2c_term_start_time',
        orderType: 'desc',
        start_term_time: null,
        end_term_time: null,
        pay_amount: null,
      },
      listType: 'term',
      apis: {
        term: {
          getList: getChannelLists,
          getSum: getChannelSum,
          loadDownload: getChannelDownload
        },
        acc: {
          getList: getChannelAccLists,
          getSum: getChannelAccSum,
          loadDownload: getChannelAccDownload
        }
      },
      createTime: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date().getTime()],
      pickerMinDate: "", // 第一次选中的时间
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date();
              const week = end.getDay();
              const millisecond = 1000 * 60 * 60 * 24;
              const minusDay = week !== 0 ? week - 1 : 6;
              const monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const currentDate = new Date();
              const currentMonth = currentDate.getMonth();
              const currentYear = currentDate.getFullYear();
              const start = new Date(currentYear, currentMonth, 1);
              const end = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              const m = start.getMonth() - 1;
              start.setDate(1);
              start.setMonth(m);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        disabledDate: time => {
          if (this.pickerMinDate) {
            const day1 = 93 * 24 * 3600 * 1000;
            const maxTime = this.pickerMinDate + day1;
            const minTime = this.pickerMinDate - day1;
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
        }
      },
      total: 1,
      allTime: [
        {
          value: 'term',
          name: '分学期'
        },
        {
          value: 'acc',
          name: '累计'
        }
      ],
      listLoading: false,
      statisticsArr: [],
      channelList: [],
      termList: [],
      teamList: [],
      updateTime: null,
      downloadParam: {},
      dataAcc: {}, // 总计
      flagOrder: null,
      chartList: []
    };
  },
  computed: {
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    }
  },
  created() {
    this.changeDate(this.createTime);
    // table
    // this.getList()
    // 获取推广渠道
    this.getChannelList()
    // 获取学期列表
    this.getTermList()
  },
  methods: {
    toPercentage,
    async exportExcel() {
      const { listQuery, listType, apis } = this;
      const { loadDownload } = apis[listType];
      try {
        const download = await loadDownload(delUndefined(listQuery));
        const { data, errCode, errMsg } = download.data;
        if (errCode === 0) {
          const downloadElement = document.createElement('a');
          downloadElement.href = data;
          downloadElement.download = '团队报表(公益课).csv'; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
        } else {
          this.$confirm(errMsg || '导出失败');
        }
      } catch (error) {
        this.$confirm('导出失败');
        console.log(error);
      }
    },
    enableChoose() {
      this.pickerMinDate = null
    },
    tableColumn({ row, rowIndex }) {
      return rowIndex === 0 ? 'row-special' : ''
    },
    handleStatus(value) {
      return value ? value === 'UNPAID' ? '未支付' : value === 'PAID' ? '已支付' : value === 'REFUND' ? '已退费' : '' : null
    },
    numberFormat(num) {
      return numFormat(num)
    },
    timestampToDate(time) {
      return timestampToDateTotal(time)
    },
    // 排序
    changeTableSort(column) {
      this.listQuery.orderColumn = column.prop;
      this.listQuery.orderType = column.order === "ascending" ? 'asc' : column.order === "descending" ? 'desc' : this.flagOrder;
      this.flagOrder = column.order === "ascending" ? 'asc' : 'desc'
      this.getList(null)
    },
    getList(btnName = '') {
      this.listLoading = true;
      const { listQuery, listType, apis } = this;
      const { index } = listQuery
      const params = delUndefined({
        ...this.listQuery,
        index: btnName === 'search' ? 1 : index,
      })
      const { getList, getSum } = apis[listType];
      const resTotal = getSum(params);
      const resList = getList(params);
      Promise.all([resTotal, resList]).then((results) => {
        const resultTotal = results && results.length && results[0] && results[0].data;
        const res = results && results.length && results[1];
        const dataAcc = resultTotal && resultTotal.errCode === 0 && resultTotal.data && resultTotal.data.length > 0
          ? resultTotal.data[0] : [];
        this.updateTime = dataAcc.load_time || null;
        this.dataAcc = dataAcc;
        if (res && res.data && res.data.data && res.data.errCode === 0 && res.data.data.length > 0) {
          this.listLoading = false;
          const { data, total } = res.data;
          const data_cnt = [{
            ...dataAcc
          }]
          const dataList = deteleObject(data_cnt.concat(data || []));
          this.dataList = dataList && dataList.length > 1 ? dataList : []
          this.total = total || 0;
          if (btnName === 'search') {
            this.listQuery.index = 1;
          }
        } else if (res.data && res.data.errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.listLoading = false;
          this.dataList = [];
          this.total = 0;
        }
      })
    },
    getChannelList() {
      const teamCode = getTeamCode()
      getChannelList(teamCode).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.channelList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.channelList = [];
        }
      });
    },
    getTermList() {
      getTermList().then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.termList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.termList = [];
        }
      });
    },
    changeDate(time) {
      const [start_term_time, end_term_time] = time;
      Object.assign(this.listQuery, {
        start_term_time: timestampToDate(start_term_time),
        end_term_time: timestampToDate(end_term_time),
      });
      this.getTermList()
      this.handleSearch()
    },
    handleSearch() {
      this.getList('search');
    },
    toggleSearch() {
      this.listQuery.orderColumn = this.listType === 'acc' ? 'promotion_channel_name' : 'b2c_term_start_time';
      this.listQuery.orderType = this.listType === 'acc' ? 'asc' : 'desc';
      this.listQuery.index = 1;
      this.listQuery.pageSize = 10;
      this.getList('search');
    }
  }
};
</script>
<style lang="less" scoped>
@import '../../styles/common.less';
.special-weight{
  font-weight: bold;
  color: #606266
}
.topRight{
  .selectWidth{
    margin-right: 10px;
    width: 100px;
  }
}
.all_con{
  .l_con, .r_con{
    display: inline-block;
    vertical-align: top;
  }
  .l_con{
    width: 100%;
  }
}
.blockTit{
  position: absolute;
  top: 4px;
  right: 20px;
  cursor: pointer;
}
.blockTit:hover{
  text-decoration: underline;
}
.btn{
    float: right;
  }
</style>
